import { render } from "./ui-button.vue?vue&type=template&id=360972cc&ts=true"
import script from "./ui-button.vue?vue&type=script&lang=ts"
export * from "./ui-button.vue?vue&type=script&lang=ts"

import "./ui-button.vue?vue&type=style&index=0&id=360972cc&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__